export var FlowReRunVersionTarget;
(function (FlowReRunVersionTarget) {
    FlowReRunVersionTarget["Original"] = "Original";
    FlowReRunVersionTarget["Published"] = "Published";
    FlowReRunVersionTarget["Latest"] = "Latest";
})(FlowReRunVersionTarget || (FlowReRunVersionTarget = {}));
export var FlowTriggerVersionTarget;
(function (FlowTriggerVersionTarget) {
    FlowTriggerVersionTarget["Published"] = "Published";
    FlowTriggerVersionTarget["PublishedElseLatestDraft"] = "PublishedElseLatestDraft";
    FlowTriggerVersionTarget["LatestDraft"] = "LatestDraft";
})(FlowTriggerVersionTarget || (FlowTriggerVersionTarget = {}));
export var FlowVersionTarget;
(function (FlowVersionTarget) {
    /**
     * Run the latest Published version
     */
    FlowVersionTarget["Published"] = "Published";
    /**
     * Pin to a specific version of a flow, irrespective of the state of that version, now or ever, as long as its pinned.
     *
     * **Note**: You can NOT Publish a flow that includes a sub-flow pinned to a non-published version
     * (i.e. all pinned sub-flows must also be published)
     */
    FlowVersionTarget["SpecificVersion"] = "SpecificVersion";
})(FlowVersionTarget || (FlowVersionTarget = {}));
//# sourceMappingURL=versionTarget.js.map